import React from "react";
import axios from "axios";
import PostBody from "./PostBody";
import SideBar from "./SideBar";
import RelatedPosts from "./RelatedPosts";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";

export default function SinglePost(){
    const [title, setTitle] = useState();
    const [content, setContent] = useState();
    const [imgId, setImgId] = useState();
    const [imgUrl, setImgUrl] = useState();
    const [isLoaded, setIsLoaded] = useState( false );
    const [imgLoaded, setImgLoaded] = useState( false )

    let { id } = useParams();

    useEffect(() => {
        axios.get('https://theallfathersdomain.000webhostapp.com/wp-json/wp/v2/books/'+id)
            .then(res => {
                setTitle(res.data.title.rendered);
                setContent(res.data.content.rendered);
                setImgId(res.data.featured_media);
                let imgFetchId = res.data.featured_media;
                console.log(res.data)
                setIsLoaded(true);

                axios.get('https://theallfathersdomain.000webhostapp.com/wp-json/wp/v2/media/'+imgFetchId)
                    .then(res2 => {
                        console.log(res2);
                        setImgUrl( res2.data.media_details.sizes.full.source_url );
                        console.log(res.data)
                        setImgLoaded(true);
                    })
                    .catch(err => console.log(err))
            })
            .catch(err => console.log(err));
    }, []);

    console.log(isLoaded, imgLoaded);

    if(!isLoaded){
        return(
            <div className="loading">Loading...</div>
        )
    }
    
    return (
        <div className="singlepost-page-container">
            <div className="singlepost-container">
                <PostBody title={title} content={content} imgUrl={imgUrl} />
                <SideBar />
            </div>
            <RelatedPosts />
        </div>
    )
}